import { apiBaseUrlGetter } from './appInitializer';
import { HttpRequest } from '@angular/common/http';

export function tokenSetter(token: string) {
  localStorage.setItem("Com.BVTPA.TraningCenter.Web.Secure", token);
}

export function tokenGetter(request?: HttpRequest<any>) {
  return localStorage.getItem("Com.BVTPA.TraningCenter.Web.Secure") ?? "";
}

export function whitelistedDomainsGetter() {
  const url = apiBaseUrlGetter();

  var hostname;
  //find & remove protocol (http, ftp, etc.) and get hostname

  if (url.indexOf("//") > -1) {
    hostname = url.split('/')[2];
  }
  else {
    hostname = url.split('/')[0];
  }

  //find & remove "?"
  hostname = hostname.split('?')[0];

  return hostname;
}

export function blacklistedRoutesGetter() {
  const apiRootUrl = apiBaseUrlGetter();
  const blacklistedRoutes: string[] = [
    apiRootUrl + "/auth/token",
    apiRootUrl + "/api/conf",
  ];
  console.log("blacklistedRoutes", blacklistedRoutes);
  return blacklistedRoutes;
}
